import GuestGuard from "../components/GuestGuard";
import ProjectsPage from "./ProjectsPage";

export default function GuestProjectsPage() {
  return (
    <GuestGuard>
      <ProjectsPage />
    </GuestGuard>
  );
}

